/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActiveInputs */

const en_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const es_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activos`)
};

const fr_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actif`)
};

const de_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktiv`)
};

const ja_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブ`)
};

const zh_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活`)
};

const ar_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشط`)
};

const id_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktif`)
};

const it_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`attivo`)
};

const ru_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`активные`)
};

const pt_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ativo`)
};

const ko_active = /** @type {(inputs: ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성`)
};

/**
* | output |
* | --- |
* | "active" |
*
* @param {ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const active = /** @type {((inputs?: ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_active(inputs)
	if (locale === "es") return es_active(inputs)
	if (locale === "fr") return fr_active(inputs)
	if (locale === "de") return de_active(inputs)
	if (locale === "ja") return ja_active(inputs)
	if (locale === "zh") return zh_active(inputs)
	if (locale === "ar") return ar_active(inputs)
	if (locale === "id") return id_active(inputs)
	if (locale === "it") return it_active(inputs)
	if (locale === "ru") return ru_active(inputs)
	if (locale === "pt") return pt_active(inputs)
	return ko_active(inputs)
});